import { useTranslation } from 'react-i18next';
import { RemoveScroll } from 'react-remove-scroll';
import { Divider, Flex, VStack } from '@chakra-ui/react';
import { LanguageSelector } from 'components/language/LanguageSelector';
import { AnimatePresence } from 'framer-motion';

import { MotionBox, useTracking } from '@izimi/components';
import { TrackingEventAction, TrackingEventCategory } from '@izimi/modules';
import { useLogout } from 'core/hooks/useLogout';
import { getExternalLinks } from 'util/links';

import { HeaderMobileNavigationMenuItem } from './HeaderMobileNavigationMenuItem';

type Props = {
  isOpen: boolean;
  onClose: VoidFunction;
};

export const HeaderMobileNavigationMenu = ({ isOpen, onClose }: Props) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { trackEvent } = useTracking();
  const logout = useLogout();

  const onLogout = () => {
    trackEvent({
      category: TrackingEventCategory.General,
      action: TrackingEventAction.LogoutButtonClicked,
    });
    logout();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <RemoveScroll>
          <MotionBox
            w='100vw'
            h='calc(100% - 80px)'
            zIndex={10}
            position='fixed'
            top='80px'
            left={0}
            bg='white'
            overflowY='auto'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}>
            <Divider />
            <VStack pt={4}>
              <HeaderMobileNavigationMenuItem
                title={t('naban:footer.privacyPolicy.label')}
                iconName='help-circle'
                href={getExternalLinks({ lang: language }).privacyPolicy}
                onClick={onClose}
              />
              <HeaderMobileNavigationMenuItem
                title={t('shared:navigation.logout')}
                iconName='logout'
                onClick={onLogout}
              />
              <Flex p={4} justifyContent='flex-start' w='100%'>
                <LanguageSelector />
              </Flex>
            </VStack>
          </MotionBox>
        </RemoveScroll>
      )}
    </AnimatePresence>
  );
};
